// Course banner imports
import AmazonVA from "../assets/CoursesImgs/Amazon Virtual Assistant.jpg";
import FullStackDM from "../assets/CoursesImgs/Full Stack Digital Marketing & AI.jpg";
import ShopifyDaraz from "../assets/CoursesImgs/Shopify & Daraz Business.jpg";
import FullStackGD from "../assets/CoursesImgs/Full Stack Graphic Designing & AI.jpg";
import UIUXDesign from "../assets/CoursesImgs/UIUX Designing for Web & App.jpg";
import WordPressDev from "../assets/CoursesImgs/WordPress Website Development.jpg";
import ReactNodeJS from "../assets/CoursesImgs/React & Node js Full Stack Development.jpg";
import MERNStack from "../assets/CoursesImgs/MERN Stack Web Development.jpg";
import PHPLaravel from "../assets/CoursesImgs/PHP Laravel Web Development.jpg";
import PythonProgramming from "../assets/CoursesImgs/Python Programming for Everyone.jpg";
import VideoEditing from "../assets/CoursesImgs/Video Editing & Animation.jpg";
import AI from "../assets/CoursesImgs/Artificial Intelligence (AI).jpg";
import MLDataScience from "../assets/CoursesImgs/Machine Learning & Data Science.jpg";
import CyberSecurity from "../assets/CoursesImgs/National Cyber Security.jpg";
import IELTS from "../assets/CoursesImgs/IELTS Preparation.jpg";
import Freelancing from "../assets/CoursesImgs/Freelancing Program.jpg";
import TextileDesign from "../assets/CoursesImgs/Textile Designing.jpg";
import DigitalEmbroidery from "../assets/CoursesImgs/Digital Embroidery.jpg";
import CGIAds from "../assets/CoursesImgs/CGI Ads.jpg";
import YouTubeMonetization from "../assets/coursebanners/YouTube Monetization.jpg";
import FlutterDev from "../assets/CoursesImgs/Flutter App Development.jpg";
import ForexTrading from "../assets/CoursesImgs/Forex Trading.jpg";
import PenetrationTesting from "../assets/CoursesImgs/Penetration Testing.jpg";
import AdvancedGoogleAds from "../assets/CoursesImgs/Advanced Google Ads.jpg";
import SEO from "../assets/CoursesImgs/SEO.jpg";

export const COURSE_PRICE = 1000;

export const AVAILABLE_COURSES = [
  { name: "Amazon Virtual Assistant", price: COURSE_PRICE, image: AmazonVA },
  { name: "Full Stack Digital Marketing & AI", price: COURSE_PRICE, image: FullStackDM },
  { name: "Shopify & Daraz Business", price: COURSE_PRICE, image: ShopifyDaraz },
  { name: "Full Stack Graphic Designing & AI", price: COURSE_PRICE, image: FullStackGD },
  { name: "UI/UX Designing for Web & App", price: COURSE_PRICE, image: UIUXDesign }, 
  { name: "WordPress Website Development", price: COURSE_PRICE, image: WordPressDev },
  { name: "React & Node.js Full Stack Development", price: COURSE_PRICE, image: ReactNodeJS },
  { name: "MERN Stack Web Development", price: COURSE_PRICE, image: MERNStack },
  { name: "PHP Laravel Web Development", price: COURSE_PRICE, image: PHPLaravel },
  { name: "Python Programming for Everyone", price: COURSE_PRICE, image: PythonProgramming },
  { name: "Video Editing & Animation", price: COURSE_PRICE, image: VideoEditing },
  { name: "Artificial Intelligence (AI)", price: COURSE_PRICE, image: AI },
  { name: "National Cyber Security", price: COURSE_PRICE, image: CyberSecurity },
  { name: "IELTS Preparation", price: COURSE_PRICE, image: IELTS },
  { name: "Freelancing Program", price: COURSE_PRICE, image: Freelancing },
  { name: "Textile Designing", price: COURSE_PRICE, image: TextileDesign },
  { name: "Digital Embroidery", price: COURSE_PRICE, image: DigitalEmbroidery },
  // { name: "CGI Ads", price: COURSE_PRICE, image: CGIAds },
  { name: "Cross platform Flutter App Development", price: COURSE_PRICE, image: FlutterDev },
  { name: "Forex Trading", price: COURSE_PRICE, image: ForexTrading },
  { name: "Penetration Testing Web Hacking", price: COURSE_PRICE, image: PenetrationTesting },
  { name: "Advanced Google Ads", price: COURSE_PRICE, image: AdvancedGoogleAds },
  { name: "Search Engine Optimization - SEO", price: COURSE_PRICE, image: SEO },
  { name: "YouTube Monetization", price: COURSE_PRICE, image: YouTubeMonetization },
];
// Total number of courses: 23
